<template>
  <svg
    class="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewBox"
    v-html="svg"
    :class="{ isArrow: isArrow }"
  ></svg>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      name: {
        type: String,
        required: true,
      },
      isArrow: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        svg: '' as string,
        viewBox: '0 0 24 24' as string,
        nameMutable: this.name as string,
      };
    },
    watch: {
      name(): void {
        this.nameMutable = this.name;
        this.getSVG();
      },
    },
    created(): void {
      this.getSVG();
    },
    methods: {
      getSVG(): void {
        if (this.nameMutable == '') {
          this.svg = '';
        } else {
          fetch(
            `https://api.cloudly.space/static/assets/products-icons/roadbook/${this.nameMutable}.svg`,
          )
            .then((resp) => resp.text())
            .then((body) => {
              const svg = document.createElement('div');
              svg.innerHTML = body;

              const svgElement = svg.querySelector('svg');
              if (svgElement) {
                this.svg = svgElement.innerHTML;
                this.viewBox = svgElement.getAttribute('viewBox') || '0 0 24 24';
              } else {
                this.svg = '';
                this.viewBox = '0 0 24 24';
              }
            })
            .catch((err) => console.warn(err));
        }
      },
    },
  });
</script>

<style lang="postcss">
  .svg-icon {
    @apply h-[20px] fill-grey-darkest flex justify-center items-center;

    &.isArrow,
    &.isArrow path {
      stroke: theme('colors.grey-light') !important;
      stroke-width: 2px !important;
    }
  }
</style>
